<template>
  <div>
    <div class="title-block">
      <div class="product-info">
        <h1 class="product-title">{{ itemDatas.Name }}</h1>
      </div>

      <div class="price-block">
        <div class="product-price">
          <span
            v-if="itemDatas.EventPrice > 0 || itemDatas.SellPrice !== itemDatas.OriginPrice"
            class="origin-price"
          >
            {{ itemDatas.OriginPrice }}
          </span>
          <span>
            {{
              itemDatas.EventPrice > 0 && itemDatas.EventPrice < itemDatas.SellPrice
                ? itemDatas.EventPrice
                : itemDatas.SellPrice
            }}
          </span>
        </div>

        <div v-if="itemDatas.Events" class="product-event-info lh-15">
          <div v-for="event in itemDatas.Events" :key="event.ID" class="h6">
            <a :href="'/campaign/' + event.ID">{{ event.Name }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ProductPrice',
  computed: {
    ...mapState('shopContent', ['itemDatas']),
  },
};
</script>
